import React from 'react'
import TableChart from './TableChart'
import SurveyCartesian from './SurveyCartesian'
import styled from 'styled-components'

const Warning = styled.div`
    font-size: 14px;
`

export default function SurveyChart({ state, height, width, widget }: SurveyChartProps): JSX.Element {
    const view = widget.jsonConfig.view

    if (width === 0 || height === 0) {
        return null
    }

    // remove chart from behind footer.
    const innerWidth = width - 10
    const innerHeight = height - 10

    if (state.surveys.length === 0) {
        if (state.loading) {
            return null
        }

        return (
            <Warning>
                <span>
                    Error: {state.asset}:{' '}
                    {state.uid ? `no data found for object uid = ${state.uid}` : 'no log selected'}
                </span>
            </Warning>
        )
    }

    switch (view) {
        case 'table':
            return <TableChart state={state} />
        case 'side':
            return (
                <SurveyCartesian
                    center={false}
                    x={'vertSect'}
                    y={'tvd'}
                    width={innerWidth}
                    height={innerHeight}
                    state={state}
                />
            )
        case 'plan':
            return (
                <SurveyCartesian
                    center={true}
                    x={'dispEw'}
                    y={'dispNs'}
                    width={innerWidth}
                    height={innerHeight}
                    state={state}
                />
            )
        default:
            return <div>{view} not implemented</div>
    }
}
